import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style={{
  enableBackground: "new 0 0 512 512"
}} xmlSpace="preserve" ref={ref} {...props}><g><path style={{
      fill: "#82AFFF"
    }} d="M473.885,88.279H38.115C17.045,88.403,0,105.517,0,126.617v73.478h512v-73.478   C512,105.517,494.955,88.403,473.885,88.279z" /><path style={{
      fill: "#82AFFF"
    }} d="M0,385.376c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345   v-73.465H0V385.376z" /></g><rect y={200.1} style={{
    fill: "#FFE15A"
  }} width={512} height={111.81} /><path style={{
    fill: "#464655"
  }} d="M12.831,413.993l193.267-153.415c2.946-2.338,2.946-6.812,0-9.151L12.824,98.007  C4.958,105.03,0,115.243,0,126.617v258.759C0,396.755,4.96,406.97,12.831,413.993z" /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /><g /></svg>;
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };